import { FileUp } from "lucide-react";

export function UploadSectionIcon() {
  return (
    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
      <FileUp className="h-[18px] w-[18px]" strokeWidth={1.8} />
    </div>
  );
}
